import Box from './Box';

const Preview = ({ image, ...rest }) => (
  <Box
    height="420px"
    backgroundSize="cover"
    backgroundImage={`url(${image})`}
    backgroundPosition="center"
    {...rest}
  ></Box>
);

export default Preview;
